import { Routes, Route } from "react-router-dom";
import React, { useEffect, lazy } from "react";
import '@syncfusion/ej2-base/styles/material.css';       // Base styles including icons
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-calendars/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-react-schedule/styles/material.css';
import InVehicleLessonsRecordings from "../Pages/InVehicleLessonsRecordings/InVehicleLessonsRecordings";
import { loadScript } from "../Helpers/utils/loadScript";

const InstituteSettings = lazy(() => import("../Pages/InstituteSettings/InstituteSettings"));
const InstituteSales = lazy(() => import("../Pages/InstituteSales/InstituteSales"));
const BatchManagement = lazy(() => import("../Pages/BatchManagement/InClassBatchManagement"));
const Conversation = lazy(() => import("../Pages/Conversation/Conversation"));
const AddCourse = lazy(() => import("../Pages/AddCourse/AddCourse"));
const UpdateCourse = lazy(() => import("../Pages/AddCourse/UpdateCourse"));
const ViewCourse = lazy(() => import("../Pages/AddCourse/ViewCourse"));
const CreateNewCourse = lazy(() => import("../Pages/CreateNewCourse/CreateNewCourses"));
const InstructorsList = lazy(() => import("../Pages/Institute/Instructors/Instructors"));
const AddInstructor = lazy(() => import("../Pages/Institute/AddInstructor/AddInstructor"));
const UpdateInstructor = lazy(() => import("../Pages/Institute/AddInstructor/UpdateInstructor"));
const AboutInstructor = lazy(() => import("../Pages/Institute/AboutInstructor (for Staff)"));
const InstructorTrainingCourses = lazy(() => import("../Pages/Institute/InstructorTrainingCourses/Index"));
const TeacherTimetable = lazy(() =>import("../Pages/Institute/TeacherTimeTable/TeacherTimeTable"));
const ManageStaffLogin = lazy(() => import("../Pages/Institute/ManageStaff/ManageStaff"));
const AddVehicle = lazy(() => import("../Pages/Institute/AddVehicle/AddVehicle"));
const ViewVehicleDetail = lazy(() => import("../Pages/Institute/AddVehicle/ViewVehicleDetail"));
const UpdateVehicle = lazy(() => import("../Pages/Institute/AddVehicle/UpdatedVehicle"));
const VehicleInventory = lazy(() => import("../Pages/VehicleInventory/VehicleInventory"));
const InstituteManageCourses = lazy(() => import("../Pages/InstituteManageCourses/InstituteManageCourses"));
const InstituteLeaveManagement = lazy(() => import("../Pages/InstituteLeaveManagement/InstituteLeaveManagement"));
const UpdateStaff = lazy(() => import("../Pages/Institute/AddStaff/UpdateStaff"));
const AddStaff = lazy(() => import("../Pages/Institute/AddStaff/AddStaff"));
const AboutStaff = lazy(() => import("../Pages/Institute/AddStaff/AboutStaff"));
const ManageInstituteLearners = lazy(() => import("../Pages/ManageInstituteLearners/ManageInstituteLearners"));
const StaffList = lazy(() => import("../Pages/Institute/staff-listing/StaffListing"));
const InstituteEnrolledStudentsInformation = lazy(() => import("../Pages/InstituteEnrolledStudentsInfo/InstituteEnrolledStudentsInfo"));
const LearnerAndInstructorSchedules = lazy(() =>import("../Pages/LearnerAndInstructorSchedules/LearnerAndInstructorSchedules"));
const InstructorLessonsDisplay = lazy(() => import("../Pages/InstructorLessonsDisplay/InstructorLessonsDisplay"));
const InstituteAddNewLearner = lazy(() => import("../Pages/InstituteAddNewLearner/InstituteAddNewLearner"));
const InstituteUsersActivityLogs = lazy(() => import("../Pages/InstituteUsersActivityLogs/InstituteUsersActivityLogs"));
const InVehicleRecording = lazy(() => import("../Pages/InVehicleRecording"));
const InClassBatchDetails = lazy(() => import("../Pages/InClassBatchDetails/InClassBatchDetails"));
const InstructorDetails = lazy(() => import("../Pages/InstructorDetails/InstructorDetails"));
const InstituteAwards = lazy(() => import("../Pages/InstituteAwards.jsx/InstituteAwardsPage"));
const CourseProgressInstructor = lazy(() => import("../Pages/Institute/CourseProgress for(Instructor)/CourseProgress_Instructor"));
const EnrolledCourseLearnerInformation = lazy(() => import("../Pages/EnrolledCourseLearnerInformation/EnrolledCourseLearnerInformation"));
const TeacherAboutStudent = lazy(() => import("../Pages/Institute/AboutStudent (For Teacher)/TeacgerAboutStudent"));
const CourseModule = lazy(() => import("../Pages/Institute/CourseModule (For Teacher)/CourseModule"));
const InstructorStudentList = lazy(() => import("../Pages/InstituteDashboard/Teacher Dashboard/instructorStudents/InstructorStudentsList"));
const PaymentSettings = lazy(() => import("../Pages/Payment Settings/PaymentSettings"));
const SchedulingNewStudentClasses = lazy(() =>import("../Pages/ScheduleNewStudentClasses/ScheduleNewStudentClasses"));
const PaymentDetails = lazy(() => import("../Pages/PaymentDetails/PaymentDetails"));
const PaymentInstallmentsInvoice = lazy(() => import("../Pages/PaymentInvoice/PaymentInvoice"));
const PickupService = lazy(() => import("../Pages/PickupService/PickupSevice"));
const SEnrolledCourse = lazy(() => import("../Pages/SingleEnrolledCourse/SingleEnrolledCourse"));
const CourseProgress = lazy(() => import("../Pages/CourseProgress/CourseProgress"));
const EnrolledCourseIns = lazy(() =>import("../Pages/Institute/EnrolledCourse By Student (For Institute)/EnrolledCourseIns"));
const AboutClient = lazy(() => import("../Pages/Institute/CourseProgress (Institute)/AboutClient"));
const RecommendedCoursesByAdmin = lazy(() =>import("../Pages/Institute/RecommendedCoursesByAdmin/RecommendedCoursesByAdmin"));
const ClassesSchedule = lazy(() =>import("../Pages/ClassesSchedule (For Student)/ClassesSchedule"));
const InstituteLessonsDisplay = lazy(() =>import("../Pages/InstituteLessons/InstituteLessons"));

const InstituteRoutes = () => (
  <React.Fragment>
    <Route path="/institute/settings" element={<InstituteSettings />} />
    <Route path="/institute/sales" element={<InstituteSales />} />
    <Route path="/institute/batchmanagement" element={<BatchManagement />} />
    <Route path="/inbox" element={<Conversation />} />

    <Route path="/all/courses" element={<InstituteManageCourses />} />
    <Route path="/AddCourse" element={<AddCourse />} />
    <Route path="/CreateNewCourse" element={<CreateNewCourse />} />
    <Route path="/UpdateCourse/:CourseId" element={<UpdateCourse />} />
    <Route path="/ViewCourse/:CourseId" element={<ViewCourse />} />

    <Route path="/Instructors/list" element={<InstructorsList />} />
    <Route path="/Instructor/add" element={<AddInstructor />} />
    <Route path="/Instructor/update/:InstructorId" element={<UpdateInstructor />} />
    <Route path="/about/instructor/:InstructorId" element={<AboutInstructor />} />
    <Route path="/about/instructor/training/courses/:InstructorId" element={<InstructorTrainingCourses />} />
    <Route path="/about/instructor/schedule/:InstructorId" element={<TeacherTimetable />} />

    <Route path="/staff/manage-login" element={<ManageStaffLogin />} />

    <Route path="/vehicle/add" element={<AddVehicle />} />
    <Route path="/vehicle/detail/:VehicleId" element={<ViewVehicleDetail />} />
    <Route path="/vehicle/update/:VehicleId" element={<UpdateVehicle />} />
    <Route path="/vehicle/inventory" element={<VehicleInventory />} />

    <Route path="/institute/leavemanagement" element={<InstituteLeaveManagement />} />

    <Route path="/staff/List" element={<StaffList />} />
    <Route path="/Admin/staff/add" element={<AddStaff />} />
    <Route path="/Admin/staff/update/:StaffId" element={<UpdateStaff />} />
    <Route path="/Admin/staff/detail/:StaffId" element={<AboutStaff />} />

    <Route path="/students/list" element={<ManageInstituteLearners />} />
    <Route path="/institute/enrolledcourse/studentinfo/:EnrollmentId" element={<InstituteEnrolledStudentsInformation />} />
    <Route path="/schedule" element={<LearnerAndInstructorSchedules />} />
    <Route path="/institute/lessons" element={<InstituteLessonsDisplay />} />
    <Route path="/Institute/AddNewLearner" element={<InstituteAddNewLearner />} />
    <Route path="/institute/useractivitylogs" element={<InstituteUsersActivityLogs />} />
    <Route path="/in-vehicle-recording" element={<InVehicleRecording />} />
    <Route path="/institute/in-vehicle-recording" element={<InVehicleLessonsRecordings />} />

    <Route path="/institute/batchdetails/:InstituteInClassAndBatchTimingId" element={<InClassBatchDetails />} />
    <Route path="/instructordetails/:InstructorId" element={<InstructorDetails />} />
    <Route path="/certificates" element={<InstituteAwards />} />

    <Route path="/teacher/CourseProgress/:EnrollmentId" element={<CourseProgressInstructor />} />
    <Route path="/enrolledcourse/learnerinfo" element={<EnrolledCourseLearnerInformation />} />
    <Route path="/teacher/AboutStudent/:EnrollmentId" element={<TeacherAboutStudent />} />
    <Route path="/teacher/CourseModule/:EnrollmentId" element={<CourseModule />} />
    <Route path="/instructorr/studentsListing" element={<InstructorStudentList />} />

    <Route path="/enrolledcourse/PaymentSetting/:EnrollmentId" element={<PaymentSettings />} />
    <Route path="/enrolledcourse/manage/:EnrollmentId" element={<SchedulingNewStudentClasses />} />
    <Route path="/enrolledcourse/pickupstudent/:EnrollmentId" element={<PickupService />} />
    <Route path="/enrolledcourse/progress/:EnrollmentId" element={<CourseProgress />} />
    <Route path="/enrolledcourse/paymentdetails/:EnrollmentId" element={<PaymentDetails />} />
    <Route path="/enrolledcourse/paymentdetails/invoice/:paymentId" element={<PaymentInstallmentsInvoice />} />
    <Route path="/enrolledcourse/coursemodule/:EnrollmentId" element={<SEnrolledCourse />} />
    <Route path="/enrolledcourse/:EnrollmentId" element={<EnrolledCourseIns />} />
    <Route path="/enrolledcourse/AboutClient/:EnrollmentId" element={<AboutClient />} />
    <Route path="/courses/recommended" element={<RecommendedCoursesByAdmin />} />
    <Route path="/enrolledcourse/upcomingclasses/:EnrollmentId" element={<ClassesSchedule />} />
    <Route path="/teacher/UpcomingClasses/:InstructorId" element={<TeacherTimetable />} />
  </React.Fragment>
);

// const InstituteRoutes = () => {

//   return (
//   <Routes>
//     <Route path="/institute/settings" element={<InstituteSettings />} />
//     <Route path="/institute/sales" element={<InstituteSales />} />
//     <Route path="/institute/batchmanagement" element={<BatchManagement />} />
//     <Route path="/inbox" element={<Conversation />} />    

//     <Route path="/all/courses" element={<InstituteManageCourses />} />
//     <Route path="/AddCourse" element={<AddCourse />} />
//     <Route path="/CreateNewCourse" element={<CreateNewCourse />} />
//     <Route path="/UpdateCourse/:CourseId" element={<UpdateCourse />} />
//     <Route path="/ViewCourse/:CourseId" element={<ViewCourse />} />

//     <Route path="/Instructors/list" element={<InstructorsList />} />
//     <Route path="/Instructor/add" element={<AddInstructor />} />
//     <Route path="/Instructor/update/:InstructorId" element={<UpdateInstructor />}/>
//     <Route path="/about/instructor/:InstructorId" element={<AboutInstructor />}/> 
//     <Route path="/about/instructor/training/courses/:InstructorId" element={<InstructorTrainingCourses />}/>
//     <Route path="/about/instructor/schedule/:InstructorId" element={<TeacherTimetable />}/>
            
//     <Route path="/staff/manage-login" element={<ManageStaffLogin />} />

//     <Route path="/vehicle/add" element={<AddVehicle />} />
//     <Route path="/vehicle/detail/:VehicleId" element={<ViewVehicleDetail />}/>
//     <Route path="/vehicle/update/:VehicleId"  element={<UpdateVehicle />}/>
//     <Route path="/vehicle/inventory" element={<VehicleInventory />} />

//     <Route path="/institute/leavemanagement" element={<InstituteLeaveManagement />}/>

//     {/* add staff */}
//     <Route path="/staff/List" element={<StaffList />} />
//     <Route path="/Admin/staff/add" element={<AddStaff />} />
//     <Route path="/Admin/staff/update/:StaffId" element={<UpdateStaff />}/>
//     <Route path="/Admin/staff/detail/:StaffId" element={<AboutStaff />} />

//     <Route path="/students/list" element={<ManageInstituteLearners />} />
//     <Route path="/institute/enrolledcourse/studentinfo/:EnrollmentId" element={<InstituteEnrolledStudentsInformation />}/> 
//     <Route path="/schedule" element={<LearnerAndInstructorSchedules />}/> 
//     <Route path="/institute/lessons" element={<InstituteLessonsDisplay />} />
//     <Route path="/Institute/AddNewLearner" element={<InstituteAddNewLearner />} />
//     <Route path="/institute/useractivitylogs" element={<InstituteUsersActivityLogs />} />
//     <Route path="/in-vehicle-recording" element={<InVehicleRecording />} />
//     <Route path="/institute/in-vehicle-recording" element={<InVehicleLessonsRecordings />} />

//     <Route path="/institute/batchdetails/:InstituteInClassAndBatchTimingId" element={<InClassBatchDetails />} />
//     <Route path="/instructordetails/:InstructorId" element={<InstructorDetails />}/>
//     <Route path="/certificates" element={<InstituteAwards />} />

//     <Route path="/teacher/CourseProgress/:EnrollmentId" element={<CourseProgressInstructor />}/> 
//     <Route path="/enrolledcourse/learnerinfo" element={<EnrolledCourseLearnerInformation />}/>
//     <Route path="/teacher/AboutStudent/:EnrollmentId" element={<TeacherAboutStudent />}/>
//     <Route path="/teacher/CourseModule/:EnrollmentId" element={<CourseModule />}/>
//     <Route path="/instructorr/studentsListing" element={<InstructorStudentList />}/>

    
//     <Route path="/enrolledcourse/PaymentSetting/:EnrollmentId" element={<PaymentSettings />} />
//     <Route path="/enrolledcourse/manage/:EnrollmentId" element={<SchedulingNewStudentClasses />}/>
//     <Route path="/enrolledcourse/pickupstudent/:EnrollmentId" element={<PickupService />}/>
//     <Route path="/enrolledcourse/progress/:EnrollmentId" element={<CourseProgress />}/>
//     <Route path="/enrolledcourse/paymentdetails/:EnrollmentId" element={<PaymentDetails />}/>
//     <Route path="/enrolledcourse/paymentdetails/invoice/:paymentId" element={<PaymentInstallmentsInvoice />}/>
//     <Route path="/enrolledcourse/coursemodule/:EnrollmentId" element={<SEnrolledCourse />}/>
//     <Route path="/enrolledcourse/:EnrollmentId" element={<EnrolledCourseIns />}/>
//     <Route path="/enrolledcourse/AboutClient/:EnrollmentId" element={<AboutClient />}/>
//     <Route path="/courses/recommended" element={<RecommendedCoursesByAdmin />} />
//     <Route path="/enrolledcourse/upcomingclasses/:EnrollmentId" element={<ClassesSchedule />}/> 
//     <Route path="/enrolledcourse/PaymentSetting/:EnrollmentId" element={<PaymentSettings />}/>
//     <Route path="/teacher/UpcomingClasses/:InstructorId" element={<TeacherTimetable />}/>    
//   </Routes>
//   )
// };

export default InstituteRoutes;
